import { Box } from "@raca2022/uikit";
import styled from "styled-components";
import BgRegenerative from "../../../../assets/img/Langding/BgRegenerative.png";
import BgRegenerative1 from "../../../../assets/img/Langding/BgRegenerative1.png";

export const Container = styled(Box)`
  width: 100%;
  padding: 4.58vw 4.16vw;
  background: #f2f9f9;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  @media only screen and (min-width: 1920px) {
    padding: 88px 80px;
  }
  @media only screen and (max-width: 1024px) {
    flex-direction: column;
    padding: 9.3vw 3.27vw;
  }
`;
export const Contenttable = styled(Box)`
  width: 60.36vw;
  max-width: 1159px;
  border-radius: 20px;
  background: #ffffff;
  box-shadow: 0px 0px 18px rgba(0, 0, 0, 0.09);
  overflow: hidden;
  div {
    :nth-child(1) {
      width: 100%;
      background: linear-gradient(360deg, #009768 1.1%, #00bb81 95.15%);
      padding: 1.92vw 3.33vw;
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 4.375vw;
      h1 {
        font-weight: 700;
        font-size: 2.6vw;
        line-height: 110%;
        color: #00e09a;
        font-family: "PoppinsBold";
      }
      p {
        font-weight: 600;
        font-size: 0.9375vw;
        line-height: 110%;
        color: #f2f9f9;
        font-family: "PoppinsSemiBold";
        span {
          font-weight: 600;
          font-size: 1.66vw;
          line-height: 110%;
          font-family: "PoppinsSemiBold";
        }
      }
    }
    :nth-child(2) {
      padding: 0px 2.1875vw 3.125vw;
      table {
        width: 100%;
        tr {
          th {
            font-weight: 600;
            font-size: 1.66vw;
            line-height: 110%;
            color: #009768;
            font-family: "PoppinsSemiBold";
            padding-bottom: 0.78vw;
          }
          td,
          p {
            font-weight: 500;
            font-size: 1.25vw;
            line-height: 110%;
            color: #8094ae;
            font-family: "PoppinsMedium";
            padding-bottom: 1.25vw;
            padding-top: 1vw;
          }
          td {
            border-bottom: 1px solid #20665e;
          }
          p {
            max-width: 270px;
            width: 14vw;
          }
        }
      }
    }
  }

  @media only screen and (min-width: 1920px) {
    div {
      :nth-child(1) {
        padding: 37px 64px;
        margin-bottom: 84px;
        h1 {
          font-size: 50px;
        }
        p {
          font-size: 18px;
          span {
            font-size: 32px;
          }
        }
      }
      :nth-child(2) {
        padding: 0px 42px 60px;
        table {
          tr {
            th {
              font-size: 32px;
              padding-bottom: 15px;
            }
            td,
            p {
              font-size: 24px;
              padding-bottom: 24px;
              padding-top: 20px;
            }
            p {
              max-width: 270px;
            }
          }
        }
      }
    }
  }
  @media only screen and (max-width: 1024px) {
    width: 100%;
    div {
      :nth-child(1) {
        padding: 4.9vw;
        margin-bottom: 4.67vw;
        h1 {
          font-size: 4.2vw;
        }
        p {
          font-size: 2.8vw;
          max-width: 29.67vw;
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          span {
            font-size: 4.67vw;
          }
        }
      }
      :nth-child(2) {
        padding: 7vw 3.27vw 3.97vw;
        table {
          tr {
            th {
              font-size: 2.8vw;
              padding-bottom: 6.5vw;
            }
            td,
            p {
              font-size: 2.8vw;
              padding-bottom: 2.8vw;
              padding-top: 2.8vw;
            }
            p {
              max-width: 30.85vw;
              width: 30.85vw;
            }
          }
        }
      }
    }
  }
`;

export const Chat = styled(Box)`
  padding: 2.39vw 2.1875vw;
  background: #ffffff;
  box-shadow: 0px 0px 18px rgba(0, 0, 0, 0.09);
  border-radius: 20px;
  width: 29.16vw;
  max-width: 560px;
  display: flex;
  flex-direction: column;
  align-items: center;
  h4 {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-weight: 500;
    font-size: 1.25vw;
    line-height: 110%;
    color: #20665e;
    font-family: "PoppinsMedium";
    margin-bottom: 1.25vw;
    :nth-child(3) {
      margin-top: 2.7vw;
      span {
        background: #13a61a;
      }
    }
    :nth-child(4) {
      span {
        background: #2d4ecf;
      }
    }
    :nth-child(5) {
      span {
        background: #febc06;
      }
    }
    :nth-child(6) {
      span {
        background: #ee2020;
      }
    }
    :nth-child(7) {
      span {
        background: #46bcc6;
      }
    }
    :nth-child(8) {
      span {
        background: #d946ec;
      }
    }
    :nth-child(9) {
      span {
        background: #ff6a03;
      }
    }
  }
  p {
    font-weight: 500;
    font-size: 1.25vw;
    line-height: 110%;
    color: #8094ae;
    font-family: "PoppinsMedium";
    position: relative;
    padding-left: 2.76vw;
    width: 16.66vw;
    max-width: 320px;
  }
  span {
    width: 1.71vw;
    height: 1.71vw;
    margin-right: 1vw;
    position: absolute;
    left: 0;
    top: 0;
    border-radius: 6px;
  }
  @media only screen and (min-width: 1920px) {
    padding: 46px 42px;
    h4 {
      font-size: 24px;
      margin-bottom: 24px;
      :nth-child(3) {
        margin-top: 52px;
      }
    }
    p {
      font-size: 24px;
      padding-left: 53px;
      max-width: 320px;
    }
    span {
      width: 33px;
      height: 33px;
      margin-right: 20px;
    }
  }
  @media only screen and (max-width: 1024px) {
    width: 100%;
    max-width: 100%;
    margin-top: 4.67vw;
    padding: 7.9vw;
    img{
        width: 46.96vw;
    }
    h4 {
        font-size: 2.8vw;
        margin-bottom: 2.8vw;
        :nth-child(3) {
          margin-top: 6vw;
        }
      }
      p {
        font-size: 2.8vw;
        padding-left: 14.25vw;
        max-width: 41.8vw;
        width: 41.8vw;
      }
      span {
        width: 3.27vw;
        height: 3.27vw;
        margin-right: 3.97vw;
        border-radius: 21.4%;
      }
  }
`;
export const ChatTitle = styled(Box)`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
  h3 {
    font-weight: 600;
    font-size: 32px;
    line-height: 110%;
    color: #20665e;
    font-family: "PoppinsSemiBold";
  }
  @media only screen and (max-width: 1024px) {
  margin-bottom: 12px;
  h3 {
    font-size: 32px;
  }
  img{
    width: 15.42vw;
  }
  }
`;
